import React, { useRef, useState } from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../../../components/AdminComponents/SideNav";
import {
  CourseTopLevelCA,
  CourseTopLevel,
} from "../../../../components/AdminComponents/MenuItems";
import { remainingViewportHeight } from "../../../../components/icons/ApplicationColor";
import {
  Card,
  Typography,
  Divider,
  Menu,
  Tooltip,
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  // Tag,
  DatePicker,
  message,
} from "antd";
import {
  FileTextOutlined,
  ReadOutlined,
  TeamOutlined,
  BranchesOutlined,
  SaveOutlined,
  BackwardOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import "../courseStyles.css";
import { useSelector } from "react-redux";
import axiosInstance from "../../../../api/Axios";
import { BUNDLE_ID_FIELD, BUNDLE_NAME_FIELD, FormInput } from "../courseForm";
import dayjs from "dayjs";
const dateFormat = "MMM DD YYYY";
const { Title, Paragraph } = Typography;
// eslint-disable-next-line no-unused-vars
const { Option } = Select;

const BundleAdd = () => {
  const location = useLocation();
  const userInfo = useSelector((state) => state.user);
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  const [activeView, setActiveView] = useState("summary");
  const [messageApi, contextHolder] = message.useMessage();
  const history = useNavigate();
  const tooltip_title = "This menu will be available after saving the bundle";
  const menuItems = [
    {
      key: "summary",
      label: (
        <div className="menu-vertical-item">
          <FileTextOutlined style={{ fontSize: "22px" }} />
          <div>Bundle Summary</div>
        </div>
      ),
      disabled: false,
    },

    {
      key: "courses",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title={tooltip_title}>
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <ReadOutlined style={{ fontSize: "22px" }} />
              <div>Courses</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
    isCAAdmin && {
      key: "users",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title={tooltip_title}>
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TeamOutlined style={{ fontSize: "22px" }} />
              <div>Users</div>
            </span>
          </Tooltip>
        </div>
      ),
    },

    isCAAdmin && {
      key: "department",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title={tooltip_title}>
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <BranchesOutlined style={{ fontSize: "22px" }} />
              <div>Department</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];
  const [form] = Form.useForm();
  const [tags, setTags] = useState([]);
  const [dueDate, setDueDate] = useState(null);
  const formRef = useRef();
  const handleChange = (value) => {
    setTags(value);
  };
  const CreateSuccessfull = (id) => {
    messageApi.open({
      type: "success",
      content: "Bundle creation success.",
      duration: 5,
    });
    setTimeout(() => {
      history(`/ca-admin/trainery-learn/bundles/listing`);
    }, 2000);
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Bundle Creation failure",
      duration: 5,
    });
  };

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  // Disable past dates - only allow today and future dates
  const disabledDate = (current) => {
    if (!current) return false;
    // Get today's date at midnight in local timezone
    const today = dayjs().startOf('day');
    // Disable dates before today
    return current && current < today;
  };

  // Disable dates before due date for deactivation date
  const disabledDeactivationDate = (current) => {
    if (!current) return false;
    const today = dayjs().startOf('day');
    // Disable dates before today
    if (current < today) return true;
    // If due date is selected, disable dates before due date
    if (dueDate) {
      return current < dayjs(dueDate).startOf('day');
    }
    return false;
  };

  const handleSubmit = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const { deactivate_on, due_date, ...rest } = normalizedValues;

    const finalValues = {
      ...rest,
      deactivate_on: deactivate_on ? dayjs(deactivate_on).format("YYYY-MM-DD") : null,
      due_date: due_date ? dayjs(due_date).format("YYYY-MM-DD") : null,
      organization: userInfo?.data?.organization?.id,
      tags: tags,
    };

    console.log("Form submitted with values:", finalValues);
    try {
      const res = await axiosInstance.post(
        `learn/bundle/?organization=${userInfo?.data?.organization?.id}`,
        finalValues,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      CreateSuccessfull(res?.data?.data?.id);
    } catch (err) {
      CreateFailed();
    }
  };
  return (
    <WrapperComponent props={wrapperProps}>
      {contextHolder}
      <div
        style={{
          background: "#f4f4f4",
          width: "100%",
          height: remainingViewportHeight(10),
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px",
          overflowY: "auto",
          gap: "24px",
          marginTop: "50px",
        }}
      >
        <div style={{ flexBasis: "10%", height: "100%" }}>
          <Card
            bordered
            hoverable
            style={{
              height: "100%",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
              display: "flex",
              flexDirection: "column",
              padding: "5px",
              background: "#F9FBFC",
            }}
            className="no-padding-no-margin"
          >
            <Title
              // level={}
              style={{
                fontSize: "15.5px",
                textAlign: "center",
                width: "100%",
                // display: "block",
                fontWeight: "600",
                letterSpacing: 0.5,
                color: "#333333",
                marginTop: "28.5px",
              }}
            >
              Add Bundle
            </Title>

            <Divider />
            <div style={{ paddingInline: "5px" }}>
              <Menu
                className="modern-sidebar-menu"
                mode="inline"
                selectedKeys={[activeView]}
                onClick={({ key }) => setActiveView(key)}
                style={{
                  flex: 1,
                  overflowY: "auto",
                  borderRight: "none",
                  width: "100%",
                  background: "transparent",
                }}
                items={menuItems}
              />
            </div>
          </Card>
        </div>
        <div style={{ flexBasis: "70%", display: "flex" }}>
          <Card
            style={{
              width: "100%",

              marginBottom: "10px",
            }}
            hoverable
          >
            <Title level={4}>Bundle Creation</Title>
            <Paragraph type="secondary">
              Create and configure your new bundle with the details below
            </Paragraph>
            <Form
              layout="vertical"
              onFinish={handleSubmit}
              name="complex-form"
              form={form}
              ref={formRef}
              //   onValuesChange={(_, allValues) => setFormValues(allValues)}
            >
              <Row gutter={16}>
                <FormInput field={{ ...BUNDLE_NAME_FIELD, span: 9 }} />
                <FormInput field={{ ...BUNDLE_ID_FIELD, span: 6 }} />
                <Col span={9}>
                  <Form.Item label="Tag" name="tags">
                    <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder="Enter tags"
                      onChange={handleChange}
                      value={tags}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={9}>
                  <Form.Item label="Due Date" name="due_date">
                    <DatePicker
                      format={dateFormat}
                      style={{ width: "100%" }}
                      placeholder="Select Due Date"
                      disabledDate={disabledDate}
                      onChange={(date) => {
                        setDueDate(date);
                        // Reset deactivation date if it's before the new due date
                        if (date) {
                          const currentDeactivate = form.getFieldValue('deactivate_on');
                          if (currentDeactivate && dayjs(currentDeactivate).startOf('day') < dayjs(date).startOf('day')) {
                            form.setFieldsValue({ deactivate_on: null });
                          }
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={9}>
                  <Form.Item label="Deactivation Date" name="deactivate_on">
                    <DatePicker
                      format={dateFormat}
                      style={{ width: "100%" }}
                      placeholder="Select Deactivation Date"
                      disabledDate={disabledDeactivationDate}
                    />
                  </Form.Item>
                </Col>
              </Row>{" "}
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Bundle Description" name="description">
                    <Input.TextArea rows={4} placeholder="Enter description" />
                  </Form.Item>
                </Col>
              </Row>
              <div
                className="group-1-box"
                style={{
                  paddingTop: "0rem",
                  paddingLeft: "0px",
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <div>
                  <div style={{ display: "inline-block" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="text"
                        htmlType="button"
                        style={{
                          background: "#D3D3D3",
                        }}
                        onClick={() => {
                          history(
                            isCAAdmin
                              ? "/ca-admin/trainery-learn/bundles/listing"
                              : "/trainery-learn/courses/listing"
                          );
                        }}
                      >
                        <BackwardOutlined />
                        Back
                      </Button>
                    </Form.Item>
                  </div>

                  <div style={{ display: "inline-block", marginLeft: "16px" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="save-update-btn"
                        // disabled
                      >
                        Save & Continue
                        <SaveOutlined />
                      </Button>
                    </Form.Item>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "16px" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="text"
                        htmlType="button"
                        onClick={() => {}}
                        style={{
                          background: "#D3D3D3",
                        }}
                      >
                        Reset
                        <RetweetOutlined />
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </div>
            </Form>
          </Card>
        </div>
        <div
          style={{ flexBasis: "20%", height: "100%", marginRight: "15px" }}
        ></div>
      </div>
    </WrapperComponent>
  );
};

export default BundleAdd;
